import { Roles } from '@cp/pages/auth/constants/AuthConstants';

export const BUBBLE_COLORS = {
  TRANSPARENT: 'rgba(250,250,250,0)', // default/don't know
  ORANGE: '#FA9E33', // ready
  PINK: '#a256ed', // logged in, waiting to be ready
  GREEN: '#33C85D' // online
};

export const BUTTON_ENABLED_TIMEOUT = 10000;

export enum AmeyoDiagnosticsMetricTypes {
  COUNTER = 'COUNTER',
  GAUGE = 'GAUGE',
  HISTOGRAM = 'HISTOGRAM'
}

export interface IAmeyoDiagnosticsEventNames {
  name: string;
  metricType: AmeyoDiagnosticsMetricTypes;
  description?: string;
}

export enum AmeyoDiagnosticEventGroup {
  TELE = 'TELE',
  FIELD = 'FIELD',
  HRC = 'HRC'
}

export interface IAmeyoDiagnosticPayload {
  metricName: string;
  metricType: AmeyoDiagnosticsMetricTypes;
  value: number | string;
  group: AmeyoDiagnosticEventGroup;
  subFlow?: string;
  metaData?: Record<string, any>;
}

export interface IPublishMetricPayload {
  agentReferenceId?: string;
  agentExtensionVersion: string;
  latestExtensionVersion: string;
  campaignId: string;
  flow: string;
  metricType: AmeyoDiagnosticsMetricTypes;
  value: string;
  roles?: Roles[];
  group: AmeyoDiagnosticEventGroup;
  clientTs: number;
  subFlow?: string;
  metaData?: Record<string, any>;
}

interface AmeyoDiagnosticsEvents<T> {
  [key: string]: T;
}

export const AmeyoDiagnosticEventNames: AmeyoDiagnosticsEvents<IAmeyoDiagnosticsEventNames> =
  Object.freeze({
    agentExtensionVersion: {
      name: 'agentExtensionVersion',
      metricType: AmeyoDiagnosticsMetricTypes.GAUGE,
      description: 'Agent Extension Version'
    },
    latestExtensionVersion: {
      name: 'latestExtensionVersion',
      metricType: AmeyoDiagnosticsMetricTypes.GAUGE,
      description: 'Latest Extension Version'
    },
    ameyoErroneousCount: {
      name: 'ameyoErroneousCount',
      metricType: AmeyoDiagnosticsMetricTypes.COUNTER,
      description: 'Ameyo Erroneous Count'
    },
    extensionStatus: {
      name: 'extensionStatus',
      metricType: AmeyoDiagnosticsMetricTypes.GAUGE,
      description: 'Extension Status (ON/OFF)'
    },
    ameyoAvailabilityStatus: {
      name: 'ameyoAvailabilityStatus',
      metricType: AmeyoDiagnosticsMetricTypes.GAUGE
    },
    lastAmeyoActiveTimeStamp: {
      name: 'lastAmeyoActiveTimeStamp',
      metricType: AmeyoDiagnosticsMetricTypes.GAUGE
    },
    amverageCallHandlingTime: {
      name: 'amverageCallHandlingTime',
      metricType: AmeyoDiagnosticsMetricTypes.GAUGE
    },
    acceptButtonClickFailedCount: {
      name: 'acceptButtonClickFailedCount',
      metricType: AmeyoDiagnosticsMetricTypes.COUNTER
    },
    rejectButtonClickFailedCount: {
      name: 'rejectButtonClickFailedCount',
      metricType: AmeyoDiagnosticsMetricTypes.COUNTER
    },
    disconnectButtonClickFailedCount: {
      name: 'disconnectButtonClickFailedCount',
      metricType: AmeyoDiagnosticsMetricTypes.COUNTER
    },
    disposeButtonClickFailedCount: {
      name: 'disconnectButtonClickFailedCount',
      metricType: AmeyoDiagnosticsMetricTypes.COUNTER
    },
    extensionOnTime: {
      name: 'extensionOnTime',
      metricType: AmeyoDiagnosticsMetricTypes.COUNTER,
      description: 'Extension On Time'
    }
  });

export const AMEYO_DIAGNOSTIC_EVENT_INTERVAL = 30 * 1000; // 30 seconds

export enum GAUGE_METRIC {
  ON = 1,
  OFF = 0
}
